import useMerchandiseCategories from './useMerchandiseCategories'

type ReturnType = [
  App.MerchandiseCategory | undefined,
  boolean,
  any,
]

interface Params {
  id?: string
  slug?: string
}

interface Options {
  disabled?: boolean
}

function useMerchandiseCategory(params: Params = {}, options: Options = {}): ReturnType {
  const [categories, fetching, error] = useMerchandiseCategories({
    categoryIds: params.id ? [params.id] : undefined,
    categorySlugs: params.slug ? [params.slug] : undefined,
  }, { disabled: options.disabled || (!params.id && !params.slug) })

  return [
    categories[0],
    fetching,
    error,
  ]
}

export default useMerchandiseCategory
